/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/User/all',[
    'global/all',
    './Users',
    './AddressBook',
    './OrderHistory',
    './OrderStatus',
    './PaymentMethods',
    './SavedOrderCart',
    './MemberAnnouncements',
    './MyReviews',
    './SavedItems',
    './PurchaseOrder',
    './UserB2B',
    './Registration',
    './DefaultShippingFlags'     // custom module
], function (Roc, User, AddressBook, OrderHistory, OrderStatus, PaymentMethods, SavedOrderCart, MemberAnnouncements, MyReviews, SavedItems, PurchaseOrder, UserB2B, Registration, DefaultShippingFlags) {

    Roc.Logger.debug('All User Dependencies Loaded');

    User.AddressBook = AddressBook;
    User.OrderHistory = OrderHistory;
    User.OrderStatus = OrderStatus;
    User.PaymentMethods = PaymentMethods;
    User.SavedOrderCart = SavedOrderCart;
    User.MemberAnnouncements = MemberAnnouncements;
    User.MyReviews = MyReviews;
    User.SavedItems = SavedItems;
    User.PurchaseOrder = PurchaseOrder;
    User.UserB2B = UserB2B;
    User.Registration = Registration;
    // custom module
    User.DefaultShippingFlags = DefaultShippingFlags;
    return User;
});

